import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import RadioOption from '../../components/RadioOption';
import { Users, Globe, Search, Twitter, Youtube, Linkedin, MoreHorizontal } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../routes';
import { FamlaServices } from '../../services';
import { useAppSelector } from '../../stores';
import { consumeAdminOnboardingTarget } from '../../utils/adminOnboardingStorage';

const referralOptions = [
    { id: 'friend', value: 'REFERRAL', icon: Users },
    { id: 'internet', value: 'INTERNET', icon: Globe },
    { id: 'search', value: 'SEARCH', icon: Search },
    { id: 'twitter', value: 'TWITTER', icon: Twitter },
    { id: 'youtube', value: 'YOUTUBE', icon: Youtube },
    { id: 'linkedin', value: 'LINKEDIN', icon: Linkedin },
    { id: 'other', value: 'OTHER', icon: MoreHorizontal },
];


interface ReferralSurveyProps {
    t: (key: string) => string
}

const ReferralSurvey = (props: ReferralSurveyProps) => {
    const { t } = props
    const navigate = useNavigate()
    const users = useAppSelector((state) => state.auth);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const selected = {
            value: selectedOption,
            description: selectedOption
        }

        try {
            await FamlaServices("api_host", `/tunnel/`, "POST", selected, users.access_token);
            navigate(consumeAdminOnboardingTarget() || Routes.HOMEVIEW);
        } catch (error) {
            navigate(consumeAdminOnboardingTarget() || Routes.HOMEVIEW);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-4">
            <div className="text-center mb-4">
                <h2 className="h5 mb-1">{t('views.referral.title')}</h2>
                <p className="small mb-0" style={{ color: 'var(--text-secondary)' }}>{t('views.referral.optional')}</p>
            </div>

            <div className="mb-5">
                {referralOptions.map((option) => (
                    <RadioOption
                        key={option.id}
                        id={option.id}
                        label={t(`views.referral.${option.id}`)}
                        checked={selectedOption === option.value}
                        onChange={() => setSelectedOption(option.value)}
                        Icon={option.icon}
                    />
                ))}
            </div>

            <div className="d-flex justify-content-between mt-4">
                <button
                    type="button"
                    className="btn btn-link text-primary d-flex align-items-center p-0 text-theme"
                    onClick={() => navigate(`${Routes.COMAPNYINVITED}/auth`)}

                >
                    <span className="me-1">←</span>
                    {t('views.referral.back')}
                </button>
                <button
                    type="submit"
                    className="btn btn-theme d-flex align-items-center"
                >
                    {t('views.referral.continue')}
                    <span className="ms-1">→</span>
                </button>
            </div>
        </form>
    );
};

export default ReferralSurvey;
